/** Shared decision policy; each sheet keeps its own lifecycle/animation. */
export const SHEET_DISMISS_DISTANCE_PX = 140;
export const SHEET_FLING_PX_PER_MS = 0.35;
export const SHEET_SETTLE_MS = 260;
export const SHEET_REJECT_HORIZONTAL_PX = 16;
export const SHEET_EDGE_PULL_ARM_PX = 10;
export const SHEET_CLICK_SUPPRESS_MS = 450;

export function shouldDismissSheet(input: { canceled?: boolean; horizontal?: boolean; dy: number; velocity: number }): boolean {
	if (input.canceled || input.horizontal || input.dy <= 0) return false;
	return input.dy >= SHEET_DISMISS_DISTANCE_PX || input.velocity >= SHEET_FLING_PX_PER_MS;
}
